<template>
  <div class="containerWidth about_announce">
    <div class="header">
      <p>即将揭晓 <span> | 满员揭晓，就等你来</span></p>
      <router-link to="/pointsMall/category">
        查看更多 <van-icon name="arrow"
      /></router-link>
    </div>
    <div class="content">
      <swiperx :swiperOptions="swiperOptions" class="open_content">
        <template #slides>
          <swiper-slide v-for="item in open_list" :key="item.id + 'cate'">
            <router-link :to="'/pointsMall/detail?id=' + item.id + '&pid='+item.sid">
              <div class="imgs">
                <img :src="item.image" :alt="item.store_name" />
              </div>
              <div class="text">
                <p class="title clamp2">{{ item.store_name }}</p>
                <!-- <p class="clamp1">透视透视搜图是</p> -->
                <p class="progress">
                  <van-progress
                    stroke-width="6"
                    :percentage="
                      ((item.go_count || 0) / (item.all_count || 0)) *
                        100 >=
                      100
                        ? 100
                        : ((item.go_count || 0) / (item.all_count || 0)) *
                          100
                    "
                    pivot-text=""
                    color="linear-gradient(to right, #f8cb3e, #f7ce4d)"
                  />
                </p>
                <p class="integral">
                  剩余<i>{{ item.def_renshu }}</i
                  >积分
                </p>
              </div>
            </router-link>
          </swiper-slide>
        </template>
      </swiperx>
    </div>
  </div>
</template>
<script>
import api from "@/request/api";
import swiperx from "@/components/swiperx.vue";
import { swiperSlide } from "vue-awesome-swiper";
export default {
  name: "categoryCom",
  components: {
    swiperx,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: "auto",
        freeMode: true,
      },
      open_list: [],
    };
  },
  mounted() {
    this.onload();
  },
  methods: {
    async onload() {
      const result = await api.store_integral.get_open_list();
      if (result.status == 200) {
        const dataArray = result.data.data;
		console.log(dataArray)
        // dataArray.sort((a, b) => {
        //   // 将 def_renshu 属性值转换为数字，然后比较
        //   const deRenshuA = parseFloat(a.def_renshu);
        //   const deRenshuB = parseFloat(b.def_renshu);

        //   if (deRenshuA < deRenshuB) {
        //     return -1;
        //   }
        //   if (deRenshuA > deRenshuB) {
        //     return 1;
        //   }
        //   return 0;
        // });
        this.open_list = dataArray;
      }
    },
  },
};
</script>
